import type { _ModuleSupport } from 'ag-charts-community';
import { type Bounds4, type Point, Vec4 } from 'ag-charts-core';
import type { FillOptions } from 'ag-charts-types';

import type { AnnotationContext } from '../annotationTypes';
import type { AnnotationScene } from './annotationScene';

export class WithBackgroundScene {
    static updateBackground<Datum extends { background: FillOptions }>(
        this: AnnotationScene & {
            background: _ModuleSupport.Path;
            getBackgroundStyles?(datum: Datum): FillOptions;
            getBackgroundPoints(datum: Datum, top: Bounds4, bottom: Bounds4, bounds: Bounds4): Point[];
        },
        datum: Datum,
        top: Bounds4,
        bottom: Bounds4,
        context: AnnotationContext
    ) {
        const { background } = this;
        const { seriesRect } = context;

        background.path.clear(true);

        const bounds = Vec4.from(0, 0, seriesRect.width, seriesRect.height);

        const points = this.getBackgroundPoints(datum, top, bottom, bounds);
        for (let i = 0; i < points.length; i++) {
            const point = points[i];
            if (i === 0) {
                background.path.moveTo(point.x, point.y);
            } else {
                background.path.lineTo(point.x, point.y);
            }
        }

        background.path.closePath();
        background.checkPathDirty();

        const backgroundStyles = this.getBackgroundStyles?.(datum) ?? datum.background;
        background.fill = backgroundStyles.fill;
        background.fillOpacity = backgroundStyles.fillOpacity ?? 1;
    }
}
